import React, { useState } from "react";
import { Media } from "react-data-table-component";
import AppDataTable from "./AppDataTable";
import Icon from "@mdi/react";
import { mdiPencil, mdiArchive } from "@mdi/js";
import { deletePartnerCompany } from "../../interpreter/partner";

export const PartnerCompanyList = ({ companies, openModal, onRefresh }) => {
  const [loading, setLoading] = useState(false);
  const [deletingId, setDeletingId] = useState(null);

  const handleDesactivar = async (row) => {
    if (!window.confirm(`¿Desactivar la empresa "${row.name}"? Los técnicos asociados no podrán ser asignados a nuevas solicitudes.`)) return;
    setDeletingId(row.id);
    try {
      const result = await deletePartnerCompany(row.id);
      if (result?.message) {
        onRefresh?.();
      } else {
        alert("Error al desactivar.");
      }
    } catch (err) {
      alert("Error al desactivar la empresa.");
    } finally {
      setDeletingId(null);
    }
  };

  const columns = [
    { name: "Cód.", selector: (row) => `00${row.id}`, sortable: true, center: true, minWidth: "60px", width: "70px" },
    { name: "Nombre", selector: (row) => row.name, sortable: true, minWidth: "120px", wrap: true },
    { name: "Email", selector: (row) => row.email ?? "—", sortable: true, minWidth: "140px", wrap: true, hide: Media.SM },
    { name: "Teléfono", selector: (row) => row.phone ?? "—", sortable: true, minWidth: "100px", hide: Media.SM },
    { name: "Suscripción", selector: (row) => row.subscription?.name ?? "—", sortable: true, minWidth: "120px", wrap: true, hide: Media.MD },
    { name: "Técnicos", selector: (row) => row.partners_count ?? 0, sortable: true, center: true, minWidth: "70px", width: "80px", hide: Media.SM },
    {
      name: "Estado",
      cell: (row) => (
        <span className={`px-2 py-0.5 rounded text-xs font-medium whitespace-nowrap ${row.status === 1 ? "bg-blue-100 text-blue-800" : "bg-gray-200 text-gray-700"}`}>
          {row.status === 1 ? "Activo" : "Desactivado"}
        </span>
      ),
      sortable: true,
      center: true,
      minWidth: "90px",
    },
    {
      name: "Acciones",
      cell: (row) => (
        <div className="flex flex-row gap-1 sm:gap-2 justify-center flex-wrap">
          <button
            onClick={() => openModal("edit", row)}
            className="flex items-center justify-center bg-blue-500 hover:bg-blue-600 text-white p-1.5 sm:px-2 sm:py-1 rounded text-xs min-w-[32px]"
            title="Editar"
          >
            <Icon path={mdiPencil} size={1.2} />
          </button>
          {row.status === 1 && (
            <button
              onClick={() => handleDesactivar(row)}
              disabled={deletingId === row.id}
              className="flex items-center justify-center bg-red-500 hover:bg-red-600 text-white p-1.5 sm:px-2 sm:py-1 rounded text-xs disabled:opacity-50 min-w-[32px] shrink-0"
              title="Desactivar"
            >
              <Icon path={mdiArchive} size={1.2} />
            </button>
          )}
        </div>
      ),
      center: true,
      minWidth: "100px",
    },
  ];

  return (
    <div className="relative w-full overflow-x-auto">
      {loading ? (
        <div className="flex justify-center items-center h-40">
          <div className="animate-spin rounded-full h-10 w-10 border-t-4 border-blue-500 border-solid" />
        </div>
      ) : (
        <div className="border rounded-lg overflow-x-auto min-w-0">
          <AppDataTable
            columns={columns}
            noDataComponent={<p className="text-gray-500 py-4 px-4">No hay empresas partner.</p>}
            data={companies}
            scrollHeight="400px"
            highlightOnHover
            responsive
            customStyles={{
              table: { style: { width: "100%" } },
              tableWrapper: { style: { overflowX: "auto", width: "100%" } },
              responsiveWrapper: { style: { overflow: "auto", maxWidth: "100%" } },
              headCells: {
                style: {
                  fontWeight: "700",
                  backgroundColor: "#eef2ff",
                  color: "#374151",
                  fontSize: "14px",
                  paddingTop: "12px",
                  paddingBottom: "12px",
                  paddingLeft: "10px",
                  paddingRight: "10px",
                },
              },
              rows: { style: { backgroundColor: "white", minHeight: "48px" } },
              cells: {
                style: {
                  fontSize: "13px",
                  color: "#4b5563",
                  paddingTop: "10px",
                  paddingBottom: "10px",
                  paddingLeft: "10px",
                  paddingRight: "10px",
                },
              },
            }}
          />
        </div>
      )}
    </div>
  );
};
